import {observer} from 'mobx-react';
import {CompanyLogo, EditableCompanyLogo} from 'shared/components';
import {auth} from 'main/tools';

const CompanyLogoSection = observer(({uiState}) => {
  const {company} = uiState;

  return (
    <div className={!company.logoUrl ? 'mb1' : null}>
      {auth.user.admin ?
        <EditableCompanyLogo onClick={() => window.open('/company_settings/general', '_blank')} company={company} /> :
        <CompanyLogo preview={true} company={company}/>}
    </div>
  );
});

export default CompanyLogoSection;
